import {
  FETCH_ALL_CURRENCY_LIST,
  FETCH_ALL_CITIES_LIST,
  FETCH_NEWS,
  FETCH_NBU_CURRENCY_LIST,
  FETCH_MB_COMMENTS,
  FETCH_MB_ARCHIVE,
  FETCH_CURRENCY_YEAR_ARCHIVE,
  FETCH_VIDEOS,
  FETCH_DISCUSSIONS,
  FETCH_ARTICLES,
  FETCH_COMPANIES_NEWS,
  FETCH_VA_CURRENCY_LIST,
} from 'actionTypes';
import { successAction } from 'utils/redux';
import createReducer from './createReducer';

const initialState = {
  currencyList: [],
  citiesList: [],
  newsList: [],
  nbuCurrencyList: [],
  mbComments: {},
  mbArchive: null,
  currencyYearArchive: null,
  videos: {},
  discussions: {},
  articlesList: [],
  companiesNewsList: [],
  currencyVaList: [],
};

const currency = createReducer(initialState, {
  [successAction(FETCH_DISCUSSIONS)]: (state, action) => ({
    ...state,
    discussions: action.payload,
  }),
  [successAction(FETCH_ALL_CURRENCY_LIST)]: (state, action) => ({
    ...state,
    currencyList: action.payload,
  }),
  [successAction(FETCH_VA_CURRENCY_LIST)]: (state, action) => ({
    ...state,
    currencyVaList: action.payload,
  }),
  [successAction(FETCH_ALL_CITIES_LIST)]: (state, action) => ({
    ...state,
    citiesList: action.payload,
  }),
  [successAction(FETCH_NEWS)]: (state, action) => ({
    ...state,
    newsList: action.payload.data,
  }),
  [successAction(FETCH_ARTICLES)]: (state, action) => ({
    ...state,
    articlesList: action.payload,
  }),
  [successAction(FETCH_COMPANIES_NEWS)]: (state, action) => ({
    ...state,
    companiesNewsList: action.payload,
  }),
  [successAction(FETCH_NBU_CURRENCY_LIST)]: (state, action) => ({
    ...state,
    nbuCurrencyList: action.payload,
  }),
  [successAction(FETCH_MB_COMMENTS)]: (state, action) => {
    return {
      ...state,
      mbComments: action.payload,
    };
  },
  [successAction(FETCH_MB_ARCHIVE)]: (state, action) => ({
    ...state,
    mbArchive: action.payload,
  }),
  [successAction(FETCH_CURRENCY_YEAR_ARCHIVE)]: (state, action) => ({
    ...state,
    currencyYearArchive: action.payload,
  }),
  [successAction(FETCH_VIDEOS)]: (state, action) => {
    let videos = {};
    if (action.isLoadMore) {
      videos = {
        ...action.payload,
        items: [...state.videos.items, ...action.payload.items],
      };
    } else {
      videos = action.payload;
    }
    return {
      ...state,
      videos,
    };
  },
});

export default currency;
